import { render, staticRenderFns } from "./FAQModal.vue?vue&type=template&id=645694c4&scoped=true&"
import script from "./FAQModal.vue?vue&type=script&lang=js&"
export * from "./FAQModal.vue?vue&type=script&lang=js&"
import style0 from "./FAQModal.vue?vue&type=style&index=0&id=645694c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../PatientEnrollment/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645694c4",
  null
  
)

export default component.exports